import {
  ArrowRight,
  LogIn,
  UserRound,
  SunMoon,
  Moon,
  Sun,
  Undo2,
  Check,
  Loader,
  Loader2,
  CircleX,
  CheckCircle2,
  Gift,
  X,
  CheckIcon,
  ArrowUp,
  Globe2,
  GraduationCap,
  Atom,
  Brain,
  LogOut,
  Settings,
  Home,
  Star,
  CreditCard,
  EllipsisVertical,
  User2,
  LifeBuoy,
  MessageCircle,
  Plus,
  Trash,
  Ellipsis,
  ClockFading,
  BadgeCheck,
  BadgeX,
  ArrowUpRight,
  Menu,
  MonitorSmartphone,
  Key,
  TrendingUp,
  PaintBucket,
  ChartNoAxesGantt,
  BookOpen,
  Webhook,
  Download,
  ChevronRight,
  SendHorizontal,
  Copy,
  ChevronsUpDown,
  ArrowDown,
  ArrowLeft,
  UserRoundPlus,
  UsersRound,
  Search,
  Filter,
  ChevronsLeft,
  ChevronLeft,
  ChevronsRight,
  Settings2,
  ChevronDown,
  EyeOff,
  ChevronUp,
  XCircle,
  MailPlus,
  PlusCircle,
  Calendar,
  ShieldUser,
  Building,
  HandCoins,
  Code,
  VenetianMask,
  Ban,
  Eye,
  Lock,
  Slash,
  MoreHorizontal,
  Circle,
  Minus,
  PanelLeft,
  FileText,
  Layers,
} from "lucide-react";

import { Icons as GlobalIcons } from "@workspace/ui/assets";

export const Icons = {
  ...GlobalIcons,
  Minus,
  PanelLeft,
  FileText,
  Layers,
  Eye,
  Slash,
  Code,
  VenetianMask,
  Lock,
  MailPlus,
  ClockFading,
  Calendar,
  ArrowRight,
  LogIn,
  UserRound,
  Key,
  SunMoon,
  ChevronRight,
  Moon,
  Sun,
  Undo2,
  Check,
  Loader2,
  CircleX,
  Ban,
  CheckCircle2,
  CheckIcon,
  Gift,
  X,
  ArrowUp,
  Globe2,
  GraduationCap,
  ChartNoAxesGantt,
  BookOpen,
  Webhook,
  Star,
  Atom,
  Brain,
  LogOut,
  Settings,
  Home,
  CreditCard,
  User2,
  EllipsisVertical,
  LifeBuoy,
  MessageCircle,
  Plus,
  Loader,
  Ellipsis,
  Trash,
  BadgeCheck,
  BadgeX,
  ArrowUpRight,
  Menu,
  MonitorSmartphone,
  Download,
  Copy,
  PaintBucket,
  SendHorizontal,
  ChevronsUpDown,
  ArrowDown,
  ArrowLeft,
  UsersRound,
  UserRoundPlus,
  Search,
  Filter,
  ChevronsLeft,
  ChevronLeft,
  ChevronsRight,
  Settings2,
  ChevronDown,
  EyeOff,
  ChevronUp,
  XCircle,
  PlusCircle,
  ShieldUser,
  Building,
  HandCoins,
  TrendingUp,
  MoreHorizontal,
  Circle,
};

export type Icon = (typeof Icons)[keyof typeof Icons];
